// ** React Imports
import { ReactNode, useEffect } from 'react'

// ** Configs

// ** Layout Import
import BlankLayout from 'src/@core/layouts/BlankLayout'
import { Box, Button, CardContent, Typography, TypographyProps, styled } from '@mui/material'
import themeConfig from 'src/configs/themeConfig'
import { GoogleAnalyticsScript } from 'src/context/common'
import MuiCard, { CardProps } from '@mui/material/Card'
import { useRouter } from 'next/router'
import { checkProd, generateCodeChallenge, generateCodeVerifier } from 'src/utils'

const TypographyStyled = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: 600,
  letterSpacing: '0.18px',
  marginBottom: theme.spacing(1.5),
  [theme.breakpoints.down('md')]: { marginTop: theme.spacing(8) }
}))

const Card = styled(MuiCard)<CardProps>(({ theme }) => ({
  [theme.breakpoints.up('sm')]: { width: 400 }
}))

const clientId = process.env.NEXT_PUBLIC_AZURE_CLINT_ID || ''
const tenantId = process.env.NEXT_PUBLIC_AZURE_TENANT_ID || ''
const redirectUri = process.env.NEXT_PUBLIC_USER_LOGIN_REDIRECT_URL || ''
const scope = process.env.NEXT_PUBLIC_AZURE_SCOPE || ''
const LoginPage = () => {
  const router = useRouter()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(GoogleAnalyticsScript.script2)
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }

        const scriptContent = await response.text()
        const scriptElement = document.createElement('script')
        scriptElement.innerHTML = scriptContent
        document.body.appendChild(scriptElement)
      } catch (error) {
        console.error('There was a problem fetching the data:', error)
      }
    }
    checkProd() && fetchData()
  }, [])

  const onSubmit = async (event: any) => {
    event.preventDefault()
    const codeVerifier = generateCodeVerifier()
    const codeChallenge = await generateCodeChallenge(codeVerifier)
    localStorage.setItem('pkce_code_verifier', codeVerifier)
    const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(
      redirectUri
    )}&response_mode=query&scope=${encodeURIComponent(
      scope
    )}&state=12345&code_challenge=${codeChallenge}&code_challenge_method=S256`
    router.push(authUrl)
  }

  return (
    <Box className='content-center p-0'>
      <img
        alt={'lgin'}
        src={`${process.env.NEXT_PUBLIC_OPERATION_BASE_URL}/images/bg-login1.jpg`}
        className='bg-login1'
        width={'100%'}
        height={'100%'}
      />

      <Box sx={{ mb: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}></Box>

      <Card sx={{ zIndex: 1 }}>
        <CardContent sx={{ p: theme => `${theme.spacing(13, 7, 6.5)} !important` }}>
          <Box sx={{ mb: 6, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <img
              src={`${process.env.NEXT_PUBLIC_OPERATION_BASE_URL}/images/reggie-logo.png`}
              width='200'
              alt='ERP logo'
            />
          </Box>

          <Box sx={{ mb: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <TypographyStyled variant='h5' sx={{ mb: 1.5, fontWeight: 600, letterSpacing: '0.18px' }}>
              {`Welcome to ${themeConfig.templateName}!`}
            </TypographyStyled>
          </Box>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <TypographyStyled variant='body2'>Sign in with your organizational Email</TypographyStyled>
          </Box>
          <form>
            <Button fullWidth size='large' variant='contained' sx={{ mb: 7, mt: 3 }} onClick={event => onSubmit(event)}>
              Login
            </Button>
          </form>
          <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <TypographyStyled align='center' variant='body2'>
              For more information please contact the IT service desk on{' '}
              <a href='tel:+27 11 669 5000'>+27 11 669 5000</a>
            </TypographyStyled>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

LoginPage.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>

LoginPage.guestGuard = true

export default LoginPage
